import SearchWoker from '../worker/search.worker';
import { processRegions } from '../modules/utilsRegions';

const searchWorker = new SearchWoker();

function closeSearch(element, noResults) {
  const panel = element.querySelector('ul.ac-results');

  if (!noResults) {
    const input = element.querySelector('.c-search__input');
    input.value = '';
  }

  panel.innerHTML = '';
  panel.style.display = 'none';
}

function showPanel(event) {
  const data = JSON.parse(event.data);
  const { listHtml, containerId } = data;
  const containerSearch = document.querySelector(`[data-container=${containerId}]`);
  const formSearch = containerSearch.querySelector('.ac-search');

  if (listHtml.length) {
    const panel = formSearch.querySelector('ul.ac-results');
    panel.innerHTML = '';
    panel.insertAdjacentHTML('beforeend', listHtml);
    panel.style.display = 'block';
  } else {
    closeSearch(formSearch, true);
  }
}

function handleEvent(event) {
  const {
    type, keyCode, currentTarget, preventDefault,
  } = event;
  const { parentElement, value } = currentTarget;
  const container = parentElement.closest('[data-container]');

  if (type === 'submit') {
    preventDefault();
  }
  if (keyCode === 27) {
    closeSearch(parentElement);
  } else if ((keyCode > 64 && keyCode < 91) || keyCode === 8 || keyCode === 229) {
    // 229 is the android keycode by default, in an keypress event.
    if (value.length) {
      const message = {
        search: value.toLowerCase().trim(),
        containerId: container.dataset.container,
      };
      if (window.ac_community_id) {
        message.communityId = window.ac_community_id;
      }
      if (window.ac_province_id) {
        message.provinceId = window.ac_province_id;
      }
      searchWorker.postMessage(message);
      searchWorker.onmessage = showPanel;
    } else {
      closeSearch(parentElement);
    }
  }
}

function addEvents(element, hierarchies) {
  if (hierarchies) {
    element.addEventListener('submit', handleEvent);
    let typingTimer;
    element.querySelector('.c-search__input').addEventListener('keydown', () => {
      clearTimeout(typingTimer);
    });

    element.querySelector('.c-search__input').addEventListener('keyup', (event) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(handleEvent(event), 250);
    });

    document.querySelector('body').addEventListener('click', (event) => {
      if (!event.target.closest('.ac-results') || event.target.classList.contains('search-result')) {
        closeSearch(element);
      }
    });

    const hierarchiesData = {};
    hierarchiesData[window.ac_election] = hierarchies;

    searchWorker.postMessage({
      initialData: processRegions(
        hierarchiesData,
        window.ac_region_levels,
        window.ac_labels.regions,
      ),
    });
  }
}

function init() {
  const searchElements = document.querySelectorAll('form.ac-search');
  if (searchElements.length > 0) {
    window.dataManager.getHierarchies().then((hierarchies) => {
      searchElements.forEach((element) => {
        addEvents(element, hierarchies);
      });
    });
  }
}

export default init;
